export const ptBR = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Jogar",
  "menu.name": "Nome",
  "menu.ballColor": "Cor da bola",
  "menu.nameColor": "Cor do nome",
  "menu.moreInfo": "Mais informações",
  "menu.moreInfoTitle": "Mais informações",
  "menu.moreInfoSubtitle": "Páginas legais, detalhes de cookies e informações de contato.",
  "menu.back": "Voltar",
  "menu.privacySettings": "Configurações de privacidade",
  "menu.cookiePolicy": "Política de cookies",
  "menu.privacyPolicy": "Política de privacidade",
  "menu.termsOfService": "Termos de serviço",
  "menu.emailButton": "Enviar e-mail",
  "menu.websiteButton": "Ver meu site",
  "menu.contactEmailLabel": "E-mail de contato:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Confira meu site:",
  "menu.nameRequired": "Digite um nome primeiro.",
  "moreInfo.privacySettings.intro1": "Você pode gerenciar suas escolhas de privacidade neste site por meio da mensagem de consentimento exibida pelo nosso provedor de publicidade quando ela estiver disponível.",
  "moreInfo.privacySettings.intro2": "Você também pode controlar cookies e armazenamento local nas configurações do seu navegador a qualquer momento.",
  "moreInfo.privacySettings.adsHeading": "Controles de publicidade",
  "moreInfo.privacySettings.adsParagraph": "Alguns anúncios podem ser fornecidos pelo Google ou por outros parceiros. As opções de anúncios personalizados também podem ser gerenciadas diretamente nas configurações de anúncios do Google.",
  "moreInfo.privacySettings.adsBullet1": "Abra os controles de anúncios do Google em myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Limpe os cookies ou dados do site se quiser redefinir suas escolhas de consentimento.",
  "moreInfo.privacySettings.adsBullet3": "Use as configurações de privacidade do navegador para bloquear ou limitar cookies.",
  "moreInfo.privacySettings.localHeading": "Configurações locais",
  "moreInfo.privacySettings.localParagraph": "Este jogo armazena preferências locais básicas, como seu nome de jogador, cores, preferência de som e idioma, para que o site possa lembrá-las no seu dispositivo.",
  "moreInfo.cookiePolicy.intro1": "Este site usa cookies e tecnologias semelhantes de armazenamento para executar o jogo, lembrar suas configurações e apoiar a publicidade.",
  "moreInfo.cookiePolicy.intro2": "Os cookies também podem ser usados para medição, prevenção de fraude e personalização de anúncios, dependendo das suas escolhas de consentimento e dos serviços ativados no site.",
  "moreInfo.cookiePolicy.typesHeading": "Tipos de cookies e armazenamento que podemos usar",
  "moreInfo.cookiePolicy.typeBullet1": "Armazenamento essencial usado para manter o site funcionando.",
  "moreInfo.cookiePolicy.typeBullet2": "Armazenamento de preferências usado para lembrar seu nome, cores, idioma e configuração de som.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookies de publicidade ou medição usados por parceiros de anúncios como o Google quando os anúncios estão ativados.",
  "moreInfo.cookiePolicy.manageHeading": "Como gerenciar cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Você pode gerenciar cookies pela mensagem de consentimento do site quando disponível ou pelas configurações do navegador. Desativar alguns cookies pode afetar recursos do site ou a exibição de anúncios.",
  "moreInfo.privacyPolicy.intro1": "Este site é um jogo de navegador operado por Michał Kierzkowski. Procuramos coletar o mínimo possível de informações pessoais.",
  "moreInfo.privacyPolicy.intro2": "Não é necessário criar conta para jogar. O jogo pode armazenar preferências locais básicas no seu dispositivo e processar dados de jogo necessários para partidas online.",
  "moreInfo.privacyPolicy.infoHeading": "Informações que podemos processar",
  "moreInfo.privacyPolicy.infoBullet1": "Seu nome de jogador escolhido e configurações cosméticas.",
  "moreInfo.privacyPolicy.infoBullet2": "Dados básicos de sessão necessários para executar recursos multijogador.",
  "moreInfo.privacyPolicy.infoBullet3": "Dados de dispositivo, navegador ou publicidade coletados por parceiros de análise ou publicidade se esses serviços estiverem ativados.",
  "moreInfo.privacyPolicy.useHeading": "Como usamos as informações",
  "moreInfo.privacyPolicy.useBullet1": "Para executar o jogo e as salas online.",
  "moreInfo.privacyPolicy.useBullet2": "Para lembrar suas configurações no seu dispositivo.",
  "moreInfo.privacyPolicy.useBullet3": "Para melhorar desempenho, segurança e estabilidade.",
  "moreInfo.privacyPolicy.useBullet4": "Para exibir anúncios quando a publicidade estiver ativada.",
  "moreInfo.privacyPolicy.contactHeading": "Contato",
  "moreInfo.privacyPolicy.contactParagraph1": "Se você tiver dúvidas sobre privacidade, entre em contato: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Site: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Ao usar este site, você concorda em usar o jogo de forma legal e justa.",
  "moreInfo.terms.intro2": "O jogo é fornecido no estado em que se encontra e pode mudar, ser interrompido ou removido a qualquer momento.",
  "moreInfo.terms.rulesHeading": "Regras",
  "moreInfo.terms.ruleBullet1": "Não abuse de bugs, trapaças, automação ou exploits.",
  "moreInfo.terms.ruleBullet2": "Não tente prejudicar o serviço ou outros jogadores.",
  "moreInfo.terms.ruleBullet3": "Não use nomes ou conteúdos ofensivos, ilegais ou enganosos.",
  "moreInfo.terms.limitationHeading": "Limitação",
  "moreInfo.terms.limitationParagraph": "Não nos responsabilizamos por perdas, interrupções ou danos resultantes do uso do site, na máxima extensão permitida por lei.",
  "moreInfo.terms.changesHeading": "Alterações",
  "moreInfo.terms.changesParagraph": "Estes termos podem ser atualizados no futuro. O uso contínuo do site após atualizações significa que você aceita os termos atualizados.",
  "status.offline": "Iniciando partida offline...",
  "status.connecting": "Conectando ao servidor...",
  "queue.title": "Aguardando uma sala",
  "queue.menu": "Voltar ao menu principal",
  "game.pressToMove": "Pressione em qualquer lugar para mover",
  "game.touchToMove": "Toque em qualquer lugar para mover",
  "game.leaderboard": "Classificação",
  "game.hp": "Vida",
  "game.level": "Nível",
  "game.xp": "XP",
  "game.respawning": "Ressurgindo...",
  "gameEnd.title": "Fim do jogo",
  "gameEnd.winTitle": "Você venceu",
  "gameEnd.subtitle": "A partida terminou. Ressurja para começar a próxima rodada ou volte ao menu.",
  "pause.title": "Menu do jogo",
  "pause.resume": "Continuar",
  "pause.menu": "Voltar ao menu principal",
  "upgrade.title": "Escolha uma melhoria",
  "upgrade.generic.title": "Melhoria",
  "upgrade.generic.description": "Melhore sua build.",
  "upgrade.newWeaponPrefix": "Nova arma:",
  "upgrade.stat.maxHp.title": "Vida máxima",
  "upgrade.stat.maxHp.description": "Aumenta a vida máxima.",
  "upgrade.stat.speed.title": "Velocidade de movimento",
  "upgrade.stat.speed.description": "Aumenta a velocidade de movimento.",
  "upgrade.stat.generic.title": "Melhoria de atributo",
  "upgrade.stat.generic.description": "Melhore seus atributos.",
  "upgrade.weapon.projectileShot.title": "Disparo de projétil",
  "upgrade.weapon.projectileShot.description": "Adiciona disparos de projéteis à sua build.",
  "upgrade.weapon.orbitingBalls.title": "Bolas orbitais",
  "upgrade.weapon.orbitingBalls.description": "Adiciona bolas orbitais à sua build.",
  "upgrade.weapon.damageZone.title": "Zona de dano",
  "upgrade.weapon.damageZone.description": "Adiciona uma zona de dano ao redor do personagem.",
  "upgrade.weapon.generic.title": "Arma",
  "upgrade.weapon.generic.description": "Adicione esta arma à sua build.",
  "upgrade.weaponUpgrade.frequency.title": "Frequência",
  "upgrade.weaponUpgrade.frequency.description": "Ataque com mais frequência.",
  "upgrade.weaponUpgrade.range.title": "Alcance",
  "upgrade.weaponUpgrade.range.description": "Aumenta o alcance da arma.",
  "upgrade.weaponUpgrade.projectileCount.title": "Quantidade de projéteis",
  "upgrade.weaponUpgrade.projectileCount.description": "Cria mais projéteis.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Velocidade do projétil",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Torna os projéteis mais rápidos.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Velocidade orbital",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Faz as bolas orbitais girarem mais rápido.",
  "upgrade.weaponUpgrade.damage.title": "Dano",
  "upgrade.weaponUpgrade.damage.description": "Causa mais dano.",
  "upgrade.weaponUpgrade.generic.title": "Melhoria de arma",
  "upgrade.weaponUpgrade.generic.description": "Melhore esta arma.",
  "defeat.title": "Derrota",
  "defeat.subtitle": "Ressurja ou volte ao menu",
  "defeat.respawn": "Ressurgir",
  "defeat.menu": "Menu principal",
  "error.generic": "Algo deu errado.",
} as const;
